import styled, { css } from 'styled-components';

import Row from 'react-bootstrap/Row';

export const CardResume = styled(Row)``;

export const ResumeCnh = styled.div`
  display: flex;
  flex-direction: column;
  ${({ marginRight }) =>
    marginRight &&
    css`
      margin-right: 120px;
    `}
`;

export const ContainerStar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;

  @media (max-width: 768px) {
    margin-top: 3rem;
  }
`;

export const ProfileHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 22px;

  @media (max-width: 768px) {
    align-items: center;
    flex-direction: column;
    gap: 20px;
  }
`;

export const ProfileImageColumn = styled.div`
  display: flex;
  flex: 0 0 165px;
  justify-content: center;

  @media (max-width: 768px) {
    flex: none;
    width: 100%;
  }
`;

export const ProfileInfoColumn = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ProfileTitle = styled.div`
  text-align: left;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const LocationMapContainer = styled.div`
  background: #fff;
  bottom: ${({ $isFullscreen }) => ($isFullscreen ? 0 : 'auto')};
  height: ${({ $isFullscreen }) => ($isFullscreen ? '100vh' : '200px')};
  left: ${({ $isFullscreen }) => ($isFullscreen ? 0 : 'auto')};
  overflow: hidden;
  position: ${({ $isFullscreen }) => ($isFullscreen ? 'fixed' : 'relative')};
  right: ${({ $isFullscreen }) => ($isFullscreen ? 0 : 'auto')};
  top: ${({ $isFullscreen }) => ($isFullscreen ? 0 : 'auto')};
  width: ${({ $isFullscreen }) => ($isFullscreen ? '100vw' : '100%')};
  z-index: ${({ $isFullscreen }) => ($isFullscreen ? 9999 : 'auto')};

  &:fullscreen {
    height: 100vh;
    width: 100vw;
  }

  .leaflet-container {
    height: 100%;
    width: 100%;
  }

  .leaflet-top,
  .leaflet-bottom {
    z-index: ${({ $isFullscreen }) => ($isFullscreen ? 10000 : 400)};
  }

  .driver-map-fullscreen-button {
    align-items: center;
    background: #fff;
    border: 0;
    border-radius: 4px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.25);
    color: #1f2a37;
    cursor: pointer;
    display: flex;
    font-size: 16px;
    height: 40px;
    justify-content: center;
    position: absolute;
    right: 12px;
    top: 12px;
    width: 40px;
    z-index: ${({ $isFullscreen }) => ($isFullscreen ? 10001 : 401)};
  }

  .driver-location-icon {
    align-items: center;
    background: #0bb7af;
    border: 2px solid #fff;
    border-radius: 50%;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
  }

  .driver-location-icon span {
    background: #fff;
    border-radius: 50%;
    display: block;
    height: 6px;
    width: 6px;
  }

  .driver-location-tooltip {
    background: #0bb7af;
    border: 0;
    border-radius: 0;
    box-shadow: none;
    color: #fff;
    font-family: inherit;
    font-size: 12px;
    line-height: 1.35;
    padding: 8px 12px;
    white-space: nowrap;
  }

  .driver-location-tooltip::before {
    border-right-color: #0bb7af;
  }
`;

export const Image = styled.div`
  background-image: url(${({ url }) => url});
  background-size: cover;
  background-position: center;
  width: 150px;
  height: 150px;
  border-radius: 100%;
  border: 5px solid #f2f2f2;
`;
